module.exports = __webpack_public_path__ + "img/pengcheng.634b80f4.png";